import React, { useRef, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";

const OTPInput = ({ length = 6, onChange }) => {
  const inputsRef = useRef([]);

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  const focusNext = (index) => {
    if (index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleChange = (e, index) => {
    const { value } = e.target;
    if (!/^[0-9a-zA-Z]?$/.test(value)) return;

    e.target.value = value.toUpperCase();
    updateOtp();
    if (value) focusNext(index);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData("Text").trim().slice(0, length);
    const chars = pastedData
      .toUpperCase()
      .replace(/[^0-9A-Z]/g, "")
      .split("");

    chars.forEach((char, i) => {
      if (inputsRef.current[i]) {
        inputsRef.current[i].value = char;
      }
    });

    updateOtp();
    inputsRef.current[chars.length - 1]?.focus();
    e.preventDefault();
  };

  const updateOtp = () => {
    const otp = inputsRef.current.map((input) => input.value).join("");
    onChange(otp);
  };

  return (
    <Row className="g-2 justify-content-center" onPaste={handlePaste}>
      {[...Array(length)].map((_, index) => (
        <Col key={index} xs={2} className="px-1">
          <Form.Control
            type="text"
            maxLength={1}
            inputMode="text"
            className="text-center fs-5 py-2"
            ref={(el) => (inputsRef.current[index] = el)}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
          />
        </Col>
      ))}
    </Row>
  );
};

export default OTPInput;
